export const environment = {
    production: false,
    apiURL: 'https://api-dev.day1cloud.com/api',
  footerLinks: {
    termsOfUse: 'https://www.deloitte.com/us/en/legal/terms-of-use.html?icid=bn_terms-of-use',
    privacyCookies: 'https://cookienotice.deloitte.com/',
    helpCentre: 'https://my.deloitte.com/misc/support'
  },
    oauth: {
        clientId: 'MyProfile',
        issuer: 'https://openam-dev.day1cloud.com/am/oauth2/realms/root/realms/alpha'

    },
     alloy: {
    sdkKey: 'b09c702a-1bd0-4117-9088-c3dbb720b7fe',
    production: false,
    journeyToken: 'J-9TwlXSKl7JXQiLvADuZc',
    journeyApplicationToken: '',
  },
}
